import { Canvas } from "@dinahmoe/dmafjs-visual";

class GradientWebGL extends Canvas {
  namespace = "visual:gradient-webgl";


  init(node, event) {
    super.init(node, event);
    node._isPaused = false;
  }

  pause(node) {
    node._isPaused = true;
  }

  resume(node) {
    node._isPaused = false;
  }

  destroy(node, event) {
    super.destroy(node, event);
  }
}

const gradientWebGL = new GradientWebGL();
export { GradientWebGL, gradientWebGL };
